export * from './team-format.pipe';
